import { render, staticRenderFns } from "./topPiece.vue?vue&type=template&id=3a4cd3c9&scoped=true&"
import script from "./topPiece.vue?vue&type=script&lang=js&"
export * from "./topPiece.vue?vue&type=script&lang=js&"
import style0 from "./topPiece.vue?vue&type=style&index=0&id=3a4cd3c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4cd3c9",
  null
  
)

export default component.exports